import { targetPortFor } from './reverseProxyInstructions'

export const REVERSE_PROXY_PUBLIC_ADDRESS_PENDING_ERROR = 'frps is up but its public address is not reachable yet'

export function appUnavailableDescription(targetUrl: string | null): string {
  const port = targetUrl ? targetPortFor(targetUrl) : null
  return port
    ? `Your local computer is connected, but your app did not respond on port ${port}. Retrying…`
    : 'Your local computer is connected, but your app did not respond. Retrying…'
}

export function proxyConnectDescription(targetUrl: string | null): string {
  const port = targetUrl ? targetPortFor(targetUrl) : null
  return port
    ? `Connect your local computer using the replayqa cli. Your app should be running on port ${port}. Retrying…`
    : 'Connect your local computer using the replayqa cli. Retrying…'
}
